import axios from "axios";
import { domain } from "../../Links/Links";
import { getCookie } from "../../../App";

export async function tomanDepostRequest(
  tomanDepositAmountInput,
  tomanDepositReceiptInput, 
  tomanDepositDateInput,
  setTomanDepositButtonStatus,
  navigate,
) {
  setTomanDepositButtonStatus(true);

  const data = {
    amount: tomanDepositAmountInput,
    receipt: tomanDepositReceiptInput,
  };

  if (tomanDepositDateInput.length > 0) {
    data["shamsi_date"] = tomanDepositDateInput;
  }
  const response = await axios.post(domain + "/toman_deposit/", data, {
    withCredentials: true,
    headers: {
      "X-CSRFToken": getCookie("csrf_token"),
      "Content-Type": "application/json",
    },
  });

  console.log(response.data)

  if (response.data.ok == "ok") {
    setTomanDepositButtonStatus(false);
    navigate("/history");
  }

}
